"use client";

import Header from "@/app/_components/header";
import { usePathname } from "next/navigation";
import UserHeader from "./user-header";

const DEFAULT_ON = [
  "/user/login",
  "/user/signup",
  "/user/recover-password",
  "/user/blocked",
];

export default function HeaderWrapper() {
  const pathname = usePathname();

  // Match exact routes
  if (DEFAULT_ON.includes(pathname)) {
    return <Header />;
  }

  return <UserHeader />;
}
